import { useCallback, useState, useEffect } from 'preact/hooks'
import qs from 'qs'
import useURL from './useUrl'

export const useQueryState = (query) => {
  const url = useURL()

  const [queryValue, setQueryValue] = useState(() => {
    const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return parsed[query]
  })

  useEffect(() => {
    const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    setQueryValue(parsed[query])
  }, [url, query])

  const setQuery = useCallback(
    (value) => {
      const existingQueries = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      })

      const queryString = qs.stringify({ ...existingQueries, [query]: value }, { skipNulls: true })

      window.history.pushState({}, '', `${window.location.pathname}?${queryString}`)
      setQueryValue(value)
    },
    [query]
  )

  return [queryValue, setQuery]
}
